const e = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.8%2030.4L24%209.6H31.2L16%2030.4H8.8ZM0%200H40V40H0V0ZM5.6%2034.4H34.4V5.6H5.6V34.4Z'%20fill='%23003F8A'/%3e%3c/svg%3e";
export {
  e as default
};
